import { render, staticRenderFns } from "./ui-transition-group.vue?vue&type=template&id=27ac207a"
import script from "./ui-transition-group.vue?vue&type=script&lang=js"
export * from "./ui-transition-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports